import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { catchError, from, switchMap, throwError } from 'rxjs';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(NzMessageService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.error('HTTP ERROR:', error);
      console.error('HTTP ERROR ERROR:', error?.error);
      const apiError = error.error;

      if (Array.isArray(apiError)) {
        console.error('API ERROR ARRAY:', apiError);
        apiError.forEach((item) => {
          if (item?.message) {
            toast.error(item.message);
          }
        });

        return throwError(() => error);
      }
      if (apiError?.errors) {
        console.error('API ERROR ERRORS:', apiError);
        Object.values(apiError.errors)
          .flat()
          .forEach((message: any) => toast.error(message));

        return throwError(() => error);
      }
      if (apiError?.detail) {
        console.error('API ERROR DETAIL:', apiError);
        toast.error(apiError.detail);
        return throwError(() => error);
      }
      if (error?.error instanceof Blob) {
        console.error('API ERROR BLOB:', apiError);
        return from(error.error.text()).pipe(
          switchMap((text) => {
            try {
              console.error('HTTP ERROR TEXT:', text);

              const problem = JSON.parse(text);
              console.error('HTTP ERROR PROBLEM:', problem);
              if (problem?.errors) {
                console.error('API ERROR PROBLEM ERRORS:', problem.errors);
                Object.values(problem.errors)
                  .flat()
                  .forEach((message: any) => toast.error(message!));
              }
              if (problem?.detail) {
                console.error('API ERROR PROBLEM DETAIL:', problem?.detail);
                toast.error(problem.detail);
                return throwError(() => error);
              }
            } catch (e) {
              toast.error('Wystąpił nieoczekiwany błąd');
              console.error('Error parsing problem details:', e);
            }
            return throwError(() => error);
          }),
        );
      }
      if (error.status === 400 && error.error?.errors) {
        const errors = error.error.errors as Record<string, string[]>;

        Object.values(errors)
          .flat()
          .forEach((message) => toast.error(message));

        return throwError(() => error);
      }

      let message = 'Wystąpił nieoczekiwany błąd';

      if (error.status === 0) {
        message = 'Brak połączenia z serwerem';
      } else if (error.status >= 500) {
        message = 'Błąd serwera';
      } else if (error.status === 401) {
        message = 'Brak autoryzacji';
      } else if (error.status === 403) {
        message = 'Brak uprawnień';
      } else if (error.status === 404) {
        message = 'Nie znaleziono zasobu';
      }

      toast.error(message);

      return throwError(() => error);
    }),
  );
};
